export default __webpack_public_path__ + "static/media/warloc_learning.b858693f.svg";